import { render, staticRenderFns } from "./CardResumenTask.vue?vue&type=template&id=4b48ebea&scoped=true&lang=pug&"
import script from "./CardResumenTask.vue?vue&type=script&lang=js&"
export * from "./CardResumenTask.vue?vue&type=script&lang=js&"
import style0 from "./CardResumenTask.vue?vue&type=style&index=0&id=4b48ebea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48ebea",
  null
  
)

export default component.exports